module.exports = ".column-header {\n    text-decoration: underline;\n}\n.col-centered{\n    float: none;\n    margin: 0 auto;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/event-search/eventsearch-manualapplication/eventsearch-manualapplication.component.css
// module id = ./src/app/components/event-search/eventsearch-manualapplication/eventsearch-manualapplication.component.css
// module chunks = main